import React from 'react'
import styled from 'styled-components'

const Breadcrumb = ({ children }) => {
  return <Wrapper className="breadcrumb">{children}</Wrapper>
}

const Wrapper = styled.li`
  color: var(--color-text2-inverted);
  display: flex;
  justify-content: center;
  align-items: center;

  &:not(:last-child) {
    &::after {
      content: '•';
      display: block;
      margin: 0 0.5em;
    }
  }

  a {
    color: var(--color-text2-inverted);
    transition: color 250ms;

    &:hover {
      color: var(--color-secondary);
    }
  }
`

export default Breadcrumb
